export enum Anchors {
	Demo = 'demo',
	Chain = 'chain',
	Pricing = 'pricing',
	About = 'about',
}
